import {
  domain_linking,
  google_analytics,
  integration_key__e_invoice_customer,
  pabbly,
} from "features/Integration/constants/Integration.constants";
import React from "react";

export const featuresHeading = {
  custom_code: "Unlock Custom Code Functionality",
  view_user_feedbacks: "Unlock feedbacks to manage your customer reviews",
  affiliate_marketing: "Unlock Affiliate Marketing",
  creatives:
    "Use professional Creatives to drive better Ad Performance and Impactful Business decisions",
  certificate_builder:
    "Unlock Professional Certificates for your users and allow them to showcase their competency",
  organisation:
    "Unlock Multi-fold Growth opportunities when working with a team",
  whatsapp_blast: (
    <span>
      <span className="butterscotch_yellow">40%</span> of our creators have
      unlocked <span className="butterscotch_yellow">5x</span> growth with
      WhatsApp Broadcast
    </span>
  ),
  refund_history: "Initiate Customer Refunds Effortlessly",
  [integration_key__e_invoice_customer]: "E-invoices (powered by ClearTax)",
  leaderboard: "Track Top Performers & Motivate Growth",
  unlimited_storage: "Upload unlimited* videos/documents to Exly cloud",
  [pabbly]: "Unlock Pabbly to connect your other apps to Exly",
  thank_you_page: "Unlock customisation of Thank you Pages",
  [google_analytics]:
    "Unlock Google Analytics to collect data about your webpage visitors",
  [domain_linking]: "Whitelabel your domain with Exly",
};

export const featuresDescription = {
  affiliate_marketing:
    "Enable Affiliate Marketing to grow your reach by rewarding partners for every successful referral",
  custom_code:
    "Unlock the Custom Code functionality to elevate your pages with your unique touch.",
  creatives: "Design & Download beautiful creatives for your social media",
  certificate_builder:
    "Create & Share Certificates with your clients who have completed your courses or workshops",
  organisation:
    "Upgrade Now to assign different roles and access to different organisation members and increase your efficiency",
  whatsapp_blast:
    "Manage feedbacks from your customers, create feedback links and choose to publish to your webpage.",
  view_user_feedbacks: "Unlock feedbacks to manage your customer reviews",
  refund_history:
    "Upgrade to easily process refunds and keep your customers satisfied with seamless transactions.",
  [integration_key__e_invoice_customer]:
    "Unlock this to be able to generate e-invoices automatically for your GST registered customers.",
  leaderboard:
    "Upgrade to unlock the leaderboard and drive engagement by showcasing top achievers in your course.",
  unlimited_storage:
    "Upgrade to unlock cloud storage for all your recorded videos, images, documents and many more!",
  [pabbly]:
    "Connect your external CRM, email or WhatsApp marketing tools, and your other apps to Exly.",
  thank_you_page:
    "Customise your thank you page. Add custom redirection links, upsell offerings and manage testimonials on the page.",
  [google_analytics]:
    "Get information about who is visiting your site, what they are looking for, and how they are getting to your site.",
  [domain_linking]:
    "Connect your own domain, send personalised offering links to your customers and remove Exly branding from links.",
};
